import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import QuickAccess from "./components/QuickAccess";
import Resources from "./components/Resources";
import UncutCompare from "./components/UncutCompare";
import Guide from "./components/Guide";
import Characters from "./components/Characters";
import Timeline from "./components/Timeline";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <QuickAccess />
        <Resources />
        <UncutCompare />
        <Guide />
        <Characters />
        <Timeline />
        <Faq />
      </main>
      <Footer />

      <a
        href="#top"
        aria-label="回到页面顶部"
        className="fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </a>
    </div>
  );
}